export default __webpack_public_path__ + "static/media/My project (83) 2 (4).0298c906.png";